var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5095 6.17578H5.18945C4.08445 6.17578 3.18945 7.12478 3.18945 8.29378V18.8818C3.18945 20.0518 4.08445 20.9998 5.18945 20.9998H16.1895C17.2945 20.9998 18.1895 20.0518 18.1895 18.8818V11.1318L14.2755 15.2758C13.9337 15.6413 13.4885 15.8938 12.9995 15.9998L10.3185 16.5678C8.56845 16.9378 7.02645 15.3048 7.37645 13.4528L7.91245 10.6138C8.00945 10.1018 8.24745 9.63078 8.59645 9.26178L11.5095 6.17578Z",
    fill: "#F1935C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0352 4.31802C19.9341 4.06205 19.7858 3.82732 19.5982 3.62602C19.4136 3.42915 19.1912 3.27165 18.9442 3.16302C18.7008 3.05615 18.4379 3.00098 18.1722 3.00098C17.9064 3.00098 17.6435 3.05615 17.4002 3.16302C17.1532 3.27165 16.9307 3.42915 16.7462 3.62602L16.2002 4.20402L19.0522 7.22402L19.5982 6.64502C19.7878 6.44524 19.9363 6.21011 20.0352 5.95302C20.2412 5.42749 20.2412 4.84355 20.0352 4.31802ZM17.6392 8.72102L14.7862 5.70002L10.0092 10.76C9.93867 10.8351 9.89114 10.9288 9.87215 11.03L9.33615 13.87C9.26615 14.24 9.57515 14.566 9.92415 14.492L12.6062 13.925C12.7037 13.9033 12.7926 13.8528 12.8612 13.78L17.6392 8.72102Z",
    fill: "#F1935C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.677f1656405e6571112f9cada138140b.svg";
export { ForwardRef as ReactComponent };